import { Divider, Tooltip } from 'antd'
import FilterDiv, { FilterText } from 'components/FilterDiv'
import SearchInput from 'components/SearchInput'
import { TableTop } from 'components/UIComponents/TableSearchFilter/Style/style'
import React from 'react'
import styled from 'styled-components'
import ResumeDownload from '../../icons/DriveTableIcon/ResumeDownload'
import NewFilterDiv from '../../NewFilterDiv'

export const StyledSearchInput = styled(SearchInput)`
  border-right: ${({ hasBorderRight }) =>
    hasBorderRight ? '1px solid #e8e8e8' : 'none'};

  .ant-form-item-control-input {
  }
`

const StyledDivider = styled(Divider)`
  margin: 0 10px;
  border-color: rgba(223, 223, 223, 1);
  height: 50px;
  align-self: center;
`
const StyledVerticalDivider = styled.div`
  width: 1px;
  height: 30px;
  background-color: #ccc;
  margin: 0 8px; /* Optional: adds space around the divider */
`

const TableSearchFilter = ({
  menu,
  totalCount = 0,
  currentCount = 0,
  searchValue,
  setSearchValue,
  open,
  setOpen,
  placeholder = 'Search by keyword',
  onOpenChange,
  CandidateMenu,
  hasBorderRight,
  doc = false,
  backgroundColor = false,
  CandidateFilter = 'true',
  resumeEnable = 'false',
  handleResumeDownloadClick = {},
  selectedStudentId,
  onApplyFilter,
  onCancelFilter,
  name = '',
  iconName,
  padding = 'true',
  onAddToGroup,
  handleCreateNewGroup,
  activeTab,
  selectedColleges,
}) => {
  const validMenu = Array.isArray(menu) ? menu : []
  const isDisabled =
    activeTab === 'groups' ||
    (activeTab === 'colleges' && (!selectedColleges || selectedColleges.length === 0))

  return (
    <TableTop
      padding
      centerVertically
      backgroundColor={backgroundColor}
      border={doc}
    >
      {CandidateMenu ? (
        <>
          <StyledSearchInput
            width={'80%'}
            placeholder={placeholder}
            bordered={false}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            hasBorderRight={hasBorderRight}
          />
          <FilterText>
            Showing {currentCount} of {totalCount}
          </FilterText>
        </>
      ) : (
        <>
          {resumeEnable === true ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                gap: '12px',
              }}
            >
              <StyledSearchInput
                width={CandidateFilter === 'true' ? '60%' : '50%'}
                placeholder={placeholder}
                bordered={false}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />

              <div
                style={{
                  width: '10%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div>
                  <StyledDivider type="vertical" />
                </div>
                <div
                  style={{
                    cursor:
                      selectedStudentId.length > 0 ? 'pointer' : 'not-allowed',
                    opacity: selectedStudentId.length > 0 ? 1 : 0.5,
                    pointerEvents:
                      selectedStudentId.length > 0 ? 'auto' : 'none',
                  }}
                  onClick={
                    selectedStudentId.length > 0
                      ? handleResumeDownloadClick
                      : undefined
                  }
                >
                  <ResumeDownload />
                </div>
              </div>

              <FilterDiv
                width="15%"
                overlayMenu={menu}
                open={open}
                setOpen={setOpen}
                onOpenChange={onOpenChange}
                unsetRightBorder={CandidateFilter}
                DWidth={'600px'}
              />

              <FilterText style={{ width: '10%', display: 'flex-end' }}>
                Showing {isNaN(currentCount) ? 0 : currentCount} of {totalCount}
              </FilterText>
            </div>
          ) : name === 'EvaluationProcess' ? (
            <>
              <StyledSearchInput
                width={CandidateFilter === 'true' ? '20%' : '75%'}
                placeholder={placeholder}
                bordered={false}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
              <NewFilterDiv
                width="15%"
                overlayMenu={validMenu}
                open={open}
                setOpen={setOpen}
                onOpenChange={onOpenChange}
                unsetRightBorder={CandidateFilter}
                DWidth={'1000px'}
                onApplyFilter={onApplyFilter}
                onCancelFilter={onCancelFilter}
              />
              <FilterText style={{ width: '10%' }}>
                Showing {isNaN(currentCount) ? 0 : currentCount} of {totalCount}
              </FilterText>
            </>
          ) : name === 'Group' ? (
            <>
              <StyledSearchInput
                width={'75%'}
                placeholder={placeholder}
                bordered={false}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
              <StyledVerticalDivider />
              <Tooltip title="Add to group">
                <div
                  style={{
                    fontSize: '16px',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    opacity: isDisabled ? 0.5 : 1,
                    pointerEvents: isDisabled ? 'none' : 'auto',
                  }}
                  onClick={() => {
                    if (isDisabled) return
                    if (activeTab === 'colleges') {
                      onAddToGroup && onAddToGroup()
                    } else {
                      handleCreateNewGroup && handleCreateNewGroup()
                    }
                  }}
                >
                  <img
                    src={iconName}
                    alt="Add"
                    style={{
                      width: 30,
                      height: 30,
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      opacity: isDisabled ? 0.5 : 1,
                    }}
                    onClick={e => {
                      if (isDisabled) return
                      e.stopPropagation()
                      if (activeTab === 'colleges') {
                        onAddToGroup && onAddToGroup()
                      } else {
                        handleCreateNewGroup && handleCreateNewGroup()
                      }
                    }}
                  />
                </div>
              </Tooltip>
              <StyledVerticalDivider />
              <FilterText style={{ width: '20%' }}>
                Showing {isNaN(currentCount) ? 0 : currentCount} of {totalCount}
              </FilterText>
            </>
          ) : (
            <>
              <StyledSearchInput
                width={CandidateFilter === 'true' ? '20%' : '25%'}
                placeholder={placeholder}
                bordered={false}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
              <FilterDiv
                width="60%"
                overlayMenu={menu}
                open={open}
                setOpen={setOpen}
                onOpenChange={onOpenChange}
                unsetRightBorder={CandidateFilter}
              />

              <FilterText style={{ width: '20%' }}>
                Showing {isNaN(currentCount) ? 0 : currentCount} of {totalCount}
              </FilterText>
            </>
          )}
        </>
      )}
    </TableTop>
  )
}

export default TableSearchFilter
